import { inject, injectable } from 'inversify';
import { IApiService, DrugFilter, IDrugService, DrugOrderBy, OrderByMode } from '@/interfaces/Services';
import { DrugModel } from '@/models/drug';
import { serializeMap } from '@/utils/transformers';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

export type PageDrugResponse = {
  data: DrugModel[],
  meta: { total: number; }
};

@injectable()
export default class DrugService implements IDrugService {
  private _api: IApiService;

  constructor(@inject(DependencyIdentifiers.ApiService) api: IApiService) {
    this._api = api;
  }

  async getMany(
    page: number = 1,
    size: number = 20,
    filter: DrugFilter = {},
    orderBy?: Map<DrugOrderBy, OrderByMode>,
  ): Promise<[DrugModel[], number]> {
    let query = `/drugs?size=${size}&page=${page}`;
    query += this.getFilterQueryParams(filter);
    if (orderBy && orderBy.size > 0) {
      query += `&orderBy=${this.serializeOrderBy(orderBy)}`;
    }

    const res = await this._api.get<PageDrugResponse>(query);
    return [res.data, res.meta.total];
  }

  async getById(id: string): Promise<DrugModel> {
    return await this._api
      .get<any>(`/drugs/${id}`)
      .then(res => res.data);
  }

  private getFilterQueryParams(filter: DrugFilter): string {
    let query = '';
    if (!!filter.drugGroupId) {
      query += `&filter[drugGroupId]=${filter.drugGroupId}`;
    }

    if (!!filter.searchQuery) {
      query += `&searchQuery=${filter.searchQuery}`;
    }

    return query;
  }

  private serializeOrderBy(orderBy: Map<DrugOrderBy, OrderByMode>) {
    return serializeMap(orderBy);
  }
}
